/* eslint-disable react/no-unknown-property */
import React, { useState, MouseEvent, useRef, useEffect } from 'react';
import {
  Dropdown,
  Icon,
  IconButton,
  Menu,
  MenuDivider,
  MenuItem,
} from '@pypestream/design-system';
import { flexRender, Header } from '@tanstack/react-table';
import { NodeColumns, TableRow, tableStore } from '../../../stores/table-store';
import { getCommonPinningStyles } from '../utils/get-common-pinning-styles';
import './header-cell.scss';

interface HeaderCellProps {
  header: Header<TableRow, unknown>;
  hidden?: boolean;
}

// const serializeValue = (value: unknown): string => {
//   if (Array.isArray(value)) return value.join(', ');
//   if (typeof value === 'object' && value !== null) return JSON.stringify(value);
//   if (value === undefined || value === null) return '';
//   return String(value);
// };

// Helper to get plain JS value from MobX observable (if needed)
// const toPlain = (value: unknown): unknown => {
//   if (
//     value &&
//     typeof value === 'object' &&
//     'toJS' in value &&
//     typeof (value as { toJS: () => unknown }).toJS === 'function'
//   ) {
//     return (value as { toJS: () => unknown }).toJS();
//   }
//   return value;
// };

export const HeaderCell: React.FC<HeaderCellProps> = ({ header, hidden }) => {
  const [dropdownActive, setDropdownActive] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [filterValues, setFilterValues] = useState<unknown[]>([]);
  const [checkedValues, setCheckedValues] = useState<string[] | undefined>(
    undefined
  );

  // Deduplicate and sort unique values using serializeValue
  // const uniqueValues = useMemo(() => {
  //   const rawValues = Array.from(header.column.getFacetedUniqueValues().keys());
  //   const seen = new Set<string>();
  //   const result: unknown[] = [];
  //   for (const value of rawValues) {
  //     const plain = toPlain(value);
  //     const serialized = serializeValue(plain);
  //     if (!seen.has(serialized)) {
  //       seen.add(serialized);
  //       result.push(value);
  //     }
  //   }
  //   // Sort by serialized value for display
  //   return result.sort((a, b) => {
  //     const sa = serializeValue(toPlain(a));
  //     const sb = serializeValue(toPlain(b));
  //     return sa < sb ? -1 : sa > sb ? 1 : 0;
  //   });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [tableStore.rowsShallow, header.column]);

  // useEffect(() => {
  //   setFilterValues(uniqueValues);
  //   if (header.column.getFilterValue()) {
  //     // Always store as serialized strings
  //     setCheckedValues(
  //       (header.column.getFilterValue() as unknown[]).map((v) =>
  //         serializeValue(toPlain(v))
  //       )
  //     );
  //   }
  // }, [uniqueValues, header.column, dropdownActive]);

  // Filter values by search (using serialized value)
  // const filteredValues = useMemo(() => {
  //   return filterValues.filter((value) =>
  //     serializeValue(toPlain(value))
  //       .toLowerCase()
  //       .includes(searchValue.toLowerCase())
  //   );
  // }, [filterValues, searchValue]);

  // // Compare checked values by serialized value
  // const isChecked = (value: unknown) => {
  //   if (!checkedValues) return true;
  //   const serialized = serializeValue(toPlain(value));
  //   return checkedValues.includes(serialized);
  // };

  // Helper to get the original value from uniqueValues by serialized string
  // const getOriginalValue = (serialized: string): unknown | undefined => {
  //   return uniqueValues.find((v) => serializeValue(toPlain(v)) === serialized);
  // };

  // const handleSelectAll = () => {
  //   if (checkedValues ? checkedValues.length === filteredValues.length : true) {
  //     setCheckedValues(undefined);
  //     header.column.setFilterValue(undefined);
  //   } else {
  //     const serializedFiltered = filteredValues.map((v) =>
  //       serializeValue(toPlain(v))
  //     );
  //     setCheckedValues(serializedFiltered);
  //     // Set filter as original values
  //     header.column.setFilterValue(filteredValues);
  //   }
  // };

  // const handleFilterChange = (value: unknown) => {
  //   const serialized = serializeValue(toPlain(value));
  //   let values: string[];
  //   if (!checkedValues) {
  //     values = uniqueValues.map((v) => serializeValue(toPlain(v)));
  //   } else {
  //     values = [...checkedValues];
  //   }
  //   const exists = values.includes(serialized);
  //   let res: string[];
  //   if (exists) {
  //     res = values.filter((v) => v !== serialized);
  //   } else {
  //     res = [...values, serialized];
  //   }
  //   if (res.length === 0) {
  //     setCheckedValues(undefined);
  //     header.column.setFilterValue(undefined);
  //   } else {
  //     setCheckedValues(res);
  //     // Map back to original values for filter
  //     const originalVals = res
  //       .map((s) => getOriginalValue(s))
  //       .filter((v) => v !== undefined);
  //     header.column.setFilterValue(originalVals);
  //   }
  // };

  const listenersRef = useRef<(() => void) | null>(null);

  useEffect(() => {
    return () => {
      // Clean up any active listeners on unmount
      if (listenersRef.current) {
        listenersRef.current();
      }
    };
  }, []);

  const resizeHandler = (e: unknown) => {
    header.getResizeHandler()(e);

    const listener = () => {
      const newWidth = header.column.getSize();
      const columnId = header.id as NodeColumns;
      tableStore.setColumnSize(columnId, newWidth);

      document.removeEventListener('mouseup', listener);
      document.removeEventListener('touchend', listener);
      listenersRef.current = null;
    };

    document.addEventListener('mouseup', listener);
    document.addEventListener('touchend', listener);

    listenersRef.current = () => {
      document.removeEventListener('mouseup', listener);
      document.removeEventListener('touchend', listener);
    };
  };

  return (
    <th
      data-hidden={hidden}
      test-id={`c-editor-table--${header.id}-th`}
      key={header.id}
      id={`editor-table-th-${header.id}`}
      className={`c-editor-table-th c-editor-table-th--${header.id} ${dropdownActive ? 'c-editor-table-th--dropdown-active' : ''} ${getCommonPinningStyles(header.column).classNames}`}
      style={{
        ...getCommonPinningStyles(header.column).styles,
        ...(hidden ? { display: 'none' } : {}),
      }}
      onContextMenu={(e: MouseEvent) => {
        e.preventDefault();
        setDropdownActive((prev) => !prev);
      }}
    >
      <span className="c-editor-table-th__inner">
        <span
          className="c-editor-table-th__inner-text"
          title={flexRender(
            header.column.columnDef.header,
            header.getContext()
          )?.toString()}
        >
          {flexRender(header.column.columnDef.header, header.getContext())}
        </span>
        <IconButton
          test-id={`c-editor-table--${header.id}-dropdown-btn`}
          name="kebab"
          size="small"
          selected={dropdownActive}
          id={`editor-table-th-${header.id}__context-trigger`}
          className="c-editor-table-th__action-btn"
          onClick={() => setDropdownActive((prev) => !prev)}
        />
      </span>

      {header.id !== 'embed' && header.column.getCanResize() === true && (
        <div
          test-id={`c-editor-table--${header.id}-resizer`}
          {...{
            onDoubleClick: () => header.column.resetSize(),
            onMouseDown: resizeHandler,
            onTouchStart: resizeHandler,
            className: `c-editor-table-th__resizer ${
              header.column.getIsResizing()
                ? 'c-editor-table-th__resizer--resizing'
                : ''
            }`,
          }}
        />
      )}

      <Dropdown
        test-id={`c-editor-table--${header.id}-dropdown`}
        active={dropdownActive}
        trigger={`editor-table-th-${header.id}__context-trigger`}
        disableTriggerListeners
        placement="right-start"
        // distance={-8}
        // skidding={28}
        onclose={() => setDropdownActive(false)}
      >
        {/* <Search
          value={searchValue}
          onInput={(e) => {
            setSearchValue(e.target.value);
          }}
          placeholder="Search values..."
        />
        <Spacer /> */}
        {/* <div style={{ maxHeight: 144, overflow: 'auto' }}>
          <Scrollbar>
            <BlockList>
              <Checkbox
                size="small"
                checked={
                  checkedValues
                    ? checkedValues.length === filteredValues.length
                    : true
                }
                onChange={handleSelectAll}
              >
                Select All
              </Checkbox>
              {filteredValues.map((value) => (
                <Checkbox
                  key={serializeValue(toPlain(value))}
                  size="small"
                  checked={isChecked(value)}
                  onChange={() => handleFilterChange(value)}
                >
                  {serializeValue(toPlain(value)) === ''
                    ? 'Empty value'
                    : serializeValue(toPlain(value))}
                </Checkbox>
              ))}
            </BlockList>
          </Scrollbar>
        </div> */}
        {/* <Spacer size="small" />
        <Stack justifyContent="end">
          <Button
            variant="secondary"
            onClick={() => {
              header.column.setFilterValue(undefined);
              setSearchValue('');
              header.column.clearSorting();
              setDropdownActive(false);
            }}
          >
            Reset
          </Button>
        </Stack>
        <Spacer size="xsmall" /> */}
        <Menu>
          {/* <MenuDivider /> */}
          <MenuItem
            selected={header.column.getIsSorted() === 'asc'}
            onClick={() => {
              if (header.column.getIsSorted() === 'asc') {
                header.column.clearSorting();
              } else {
                header.column.clearSorting();
                header.column.toggleSorting(false);
              }
            }}
          >
            <Icon size="small" name="sort-down" slot="prefix" />
            Sort A to Z
          </MenuItem>
          <MenuItem
            selected={header.column.getIsSorted() === 'desc'}
            onClick={() => {
              if (header.column.getIsSorted() === 'desc') {
                header.column.clearSorting();
              } else {
                header.column.clearSorting();
                header.column.toggleSorting(true);
              }
            }}
          >
            <Icon size="small" name="sort" slot="prefix" />
            Sort Z to A
          </MenuItem>
          <MenuDivider />
          <MenuItem
            selected={!header.column.getIsPinned()}
            onClick={() => {
              header.column.pin(false);
            }}
          >
            <Icon size="small" name="no-pin" slot="prefix" />
            No Pin
          </MenuItem>
          <MenuItem
            selected={header.column.getIsPinned() === 'left'}
            onClick={() => {
              header.column.pin('left');
            }}
          >
            <Icon size="small" name="pin-left" slot="prefix" />
            Pin left
          </MenuItem>
          <MenuItem
            selected={header.column.getIsPinned() === 'right'}
            onClick={() => {
              header.column.pin('right');
            }}
          >
            <Icon size="small" name="pin-right" slot="prefix" />
            Pin right
          </MenuItem>
        </Menu>
      </Dropdown>
    </th>
  );
};
